import get from 'lodash/get'

import store from '../store'

/**
 * Test if the given masterclass id is complete
 * @param {string} masterclassId
 * @returns {boolean}
 */
export function isMasterclassComplete(masterclassId) {
  const masterclass = get(store, ['state', 'lesson', 'theme', 'byId', masterclassId], null)

  if (!masterclass) return false

  return masterclass.lessonSteps.every(isLessonStepComplete)
}

/**
 * Test if the given masterclass id is started (might be completed)
 * @param {string} masterclassId
 * @returns {boolean}
 */
export function isMasterclassStarted(masterclassId) {
  const masterclass = get(store, ['state', 'lesson', 'theme', 'byId', masterclassId], null)

  if (!masterclass) return false

  return masterclass.lessonSteps.some(isLessonStepStarted)
}

/**
 * Test if the given lesson step id is complete
 * @param {string} lessonStepId
 * @returns {boolean}
 */
export function isLessonStepComplete(lessonStepId) {
  const lessonStep = get(store, ['state', 'lesson', 'lessonStep', 'byId', lessonStepId], null)

  if (!lessonStep) return false

  return lessonStep.lessons.every(isLessonComplete)
}

/**
 * Test if the given lesson step id is started (might be completed)
 * @param {string} lessonStepId
 * @returns {boolean}
 */
export function isLessonStepStarted(lessonStepId) {
  const lessonStep = get(store, ['state', 'lesson', 'lessonStep', 'byId', lessonStepId], null)

  if (!lessonStep) return false

  return lessonStep.lessons.some(isLessonComplete)
}

/**
 * Test if the given lesson id is complete
 * @param {string} lessonId
 * @returns {boolean}
 */
export function isLessonComplete(lessonId) {
  const status = getContentStatus('lesson', lessonId)

  return status ? status.complete : false
}

/**
 * Test if the given quiz id is complete
 * @param {string} quizId
 * @returns {boolean}
 */
 export function isQuizComplete(quizId) {
  const result = store.getters.quizResultByQuiz(store.getters.quizById(quizId))
  return result >= 50.0 ? true : false
}

/**
 * Test if the given tasting id is complete
 * @param {string} tastingId
 * @returns {boolean}
 */
export function isTastingComplete(tastingId) {
  const status = getContentStatus('tasting', tastingId)

  return status ? status.complete : false
}

/**
 * Get the content status
 * @param {'quiz' | 'tasting' | 'lesson'} contentType
 * @param {string} contentId
 * @returns {mixed}
 */
function getContentStatus(contentType, contentId) {
  return get(store, ['state', 'completion', contentType, contentId], null)
}
/**
 * Get the percentage of completion of a Theme
 * @param {string} themeId
 * @returns {number}
 */
 export function getThemePercentage(themeId) {
  const theme = get(store, ['state', 'lesson', 'theme', 'byId', themeId], null)
  let lessons = theme.lessonSteps
  let themeDuration = lessons.length
  let totalComplete = 0

  lessons.forEach(lesson => {
    totalComplete += isLessonStepComplete(lesson) ? 1 : 0
  });

  return (totalComplete / themeDuration) * 100
}


/**
 * Get the percentage of completion of a Theme for quiz
 * @param {string} themeId
 * @returns {number}
 */
export function getThemePercentageQuiz(themeId) {
  const theme = get(store, ['state', 'lesson', 'theme', 'byId', themeId], null)
  let lessons = theme.lessonSteps
  let themeDuration = 0
  let totalComplete = 0

  lessons.forEach(lesson => {
    let lessonStep = store.state.lesson.lessonStep.byId[lesson]
    themeDuration += lessonStep.quizId ? 1 : 0
    if (lessonStep.quizId) {
      totalComplete += isQuizComplete(lessonStep.quizId) ? 1 : 0
    }
  });
  if (themeDuration == 0) return 0
  return (totalComplete / themeDuration) * 100
}

/**
 * Get the color of a Theme depending on his percentage
 * @param {string} themeId
 * @returns {string}
 */
export function getThemeColor(themeId) {
  let percentage = getThemePercentageQuiz(themeId)

  if (percentage == 0) return '#838383'
  else if(percentage > 0 && percentage < 25) return '#F6B43C'
  else if(percentage >= 25 && percentage < 50) return '#F39136'
  else if(percentage >= 50 && percentage < 75) return '#EC632C'
  else if(percentage >= 75 && percentage < 99) return '#E51924'
  else return '#D00E4A'
}
